export enum TeamsManagedBy {
  DIR_SYNC = "DIR_SYNC",
  MANUAL = "MANUAL",
  UNSPECIFIED = "UNSPECIFIED",
}
